 /*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */

 import React from "react";
 import { StoryWrapper } from "../story-wrapper";
 
 export const EventStory = props => {
   return <StoryWrapper {...props} />;
 };
 
 EventStory.defaultProps = {
   storyStoreField: "story",
   storyPageType: "events-story"
 };
 export default EventStory;
 